import styles from "Pages/Orders/Show.module.scss";
import OrderLineDetails from "./OrderLineDetails";
import {IOrderLineDto} from "Apis/Models/IOrderDto";
import { useTranslation } from "react-i18next";
import FlexRow from "Components/FlexRow";
import {formatNumber} from "../../../Utils/NumberUtils";
import {
    getOrderLinesProductionCount,
    getOrderLinesTotal,
    getOrderLinesTotalCost,
    getOrderLinesTotalInclVat,
    getOrderLinesTotalVat
} from "../Utils/OrderLineUtils";

interface IProps {
    lines: IOrderLineDto[];
}
const OrderLineGroup = ({lines}: IProps) => {

    const { t } = useTranslation();

    return (
        <div>
            {lines.map(x => <OrderLineDetails key={x.id} orderLine={x} />)}

            <FlexRow justify={"end"}>
                <div className={styles.total}>
                    
                    <div className={styles.underline}>
                        <div>
                            Samlet antal varer
                        </div>
                        <div>
                            {getOrderLinesProductionCount(lines)}
                        </div>
                    </div>
                    
                    <div className={styles.underline}>
                        <div>
                            {t('costs')}
                        </div>
                        <div>
                            {formatNumber(getOrderLinesTotalCost(lines))} DKK
                        </div>
                    </div>

                    <div>
                        <div>
                            {t('subTotal')}
                        </div>
                        <div>
                            {formatNumber(getOrderLinesTotal(lines))} DKK
                        </div>
                    </div>

                    <div>
                        <div>
                            {t('vat')}
                        </div>
                        <div>
                            {formatNumber(getOrderLinesTotalVat(lines))} DKK
                        </div>
                    </div>

                    <div className={styles.underline}>
                        <div>
                            {t('totalInclVat')}
                        </div>
                        <div>
                            {formatNumber(getOrderLinesTotalInclVat(lines))} DKK
                        </div>
                    </div>

                    <div>
                        <div>
                            {t('profit')}
                        </div>
                        <div>
                            {formatNumber(getOrderLinesTotal(lines) - getOrderLinesTotalCost(lines))} DKK
                        </div>
                    </div>
                </div>
            </FlexRow>
        </div>
    )

}

export default OrderLineGroup
